// extracted by mini-css-extract-plugin
export default {"list":"UploadBlock__list--V26v9"};